import { usePostHogCapture } from '@app/core/integrations/posthog/usePostHogCapture';
import { DependencyList, useCallback } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { HotkeyDefInput } from './hotkeys.types';

const DEFAULT_HOTKEY_OPTIONS = {
  enableOnFormTags: false,
  preventDefault: true,
} as const;

/**
 * Wraps useHotkeys with default options (no form tags, preventDefault), runs the given
 * callback on key press, and captures the hotkey usage to PostHog with the hotkey label and key.
 * Accepts HotkeyDefInput so the label can be sent to PostHog for analytics.
 */
export function useHotkey(hotkeyDef: HotkeyDefInput, callback: () => void, deps?: DependencyList) {
  const capture = usePostHogCapture({ domain: 'hotkey' });

  const handler = useCallback(() => {
    capture('hotkey', { label: hotkeyDef.label.defaultMessage, key: hotkeyDef.key });
    callback();
  }, [callback, capture, hotkeyDef.key]);

  useHotkeys(hotkeyDef.key, handler, DEFAULT_HOTKEY_OPTIONS, deps ?? [handler]);
}
